
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1599549785172",
    "class": "icon",
    "viewBox": "0 0 1102 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3880",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M601.245538 272.147692l154.624 448.984616 55.217231 28.041846c36.312615 17.959385 76.878769 3.938462 87.827693-30.168616l33.083076-57.028923 163.209847-314.840615c17.486769-36.548923 3.465846-77.193846-30.404923-88.379077L544.768 19.298462C510.739692 8.270769 460.8-5.12 420.548923 8.979692l-119.729231 47.261539 192.827077 77.981538c36.076308 18.038154 79.399385 56.32 107.598769 137.924923z m122.249847 519.483077L538.702769 254.424615c-11.657846-33.949538-41.590154-76.957538-75.618461-88.142769L234.023385 70.183385a84.913231 84.913231 0 0 0-94.28677 32.610461L11.500308 321.851077c-19.928615 29.696-10.24 79.714462 1.496615 113.664l184.871385 537.284923c5.041231 36.312615 32.295385 49.782154 72.62523 35.84h-0.157538l418.028308-143.911385c33.634462-11.657846 46.946462-39.148308 35.131077-73.097846z m-448.196923-453.868307a50.648615 50.648615 0 0 1-64.196924-31.507693c-9.846154-28.829538 2.599385-54.508308 31.192616-64.275692 28.514462-9.846154 54.193231 2.756923 64.039384 31.507692a50.412308 50.412308 0 0 1-31.035076 64.275693z",
        "p-id": "3881"
      }
    }
  ]
})
    }
  